import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('dependentForm', 'assigned-guardians');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dependent_registration',
  type: 'get',
  slug: [
    'guardian_proxies',
    {
      type: 'payload.query',
      queryParameter: 'first_name',
      selector: ['firstName'],
    },
    {
      type: 'payload.query',
      queryParameter: 'last_name',
      selector: ['lastName'],
    },
    {
      type: 'payload.query',
      queryParameter: 'dob',
      selector: ['dob'],
    },
    {
      type: 'payload.query',
      queryParameter: 'ssn',
      selector: ['ssn'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/dependentForm/assigned-guardian-list-req.js